module.exports = __webpack_public_path__ + "static/media/maker.2d927b92.png";